.tag {
  align-items: center;
  background-color: var(--tag-background-color);
  border-radius: var(--border-radius-lg);
  color: var(--tag-color);
  display: flex;
  height: fit-content;
  margin: var(--margin-top) var(--margin-right) var(--margin-bottom) var(--margin-left);
  padding: var(--padding-top) var(--padding-right) var(--padding-bottom) var(--padding-left);
  width: fit-content;
}

.tag__small {
  border-radius: var(--border-radius-sm);
}
